
import React from 'react';

export const ContactSection: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              For Cabin Availability
            </h3>
            <a 
              href="mailto:ops.blr@primemeridiantravel.in"
              className="text-lg text-emerald-600 hover:text-emerald-700 transition-colors"
            >
              ops.blr@primemeridiantravel.in
            </a>
          </div>
          
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Customer Support
            </h3>
            <a 
              href="tel:+919894711820"
              className="text-lg text-emerald-600 hover:text-emerald-700 transition-colors"
            >
              +91 9894711820
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
